module.exports = __webpack_public_path__ + "static/media/print2.9af79da7.jpg";